<div class="owner-actions" [class.is-active]="isMenuOpen">
  <button (click)="openUserMenu($event)" class="user-menu-btn">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </button>
  <div class="owner-menu">
    @if (!isPinnedPost) {
      <div (click)="pinPost($event)" class="menu-item">
        <outlaw-icon name="pinEmpty" size="12px"></outlaw-icon>
        Pin
      </div>
    } @else {
      <div (click)="unpinPost($event)" class="menu-item">
        <outlaw-icon name="pinEmpty" size="12px"></outlaw-icon>
        Unpin
      </div>
    }
    @if (isSelfPost) {
      <div (click)="editPost($event)" class="menu-item">
        <outlaw-icon name="edit" size="12px"></outlaw-icon>
        Edit
      </div>
    }
    <div (click)="deletePost($event)" class="menu-item">
      <outlaw-icon name="trash" size="12px"></outlaw-icon>
      Delete
    </div>
  </div>
</div>
